import { Badge, Box, Card, Flex, Grid, Heading, Inset, Spinner, Text } from '@radix-ui/themes'
import { useState } from 'react'
import useSWR from 'swr'

import { VehicleDialog } from '../components/vehicle-dialog'

import { ScreenWrapper } from '@/modules/common/components/ScreenWrapper'
import { makeUrlImage } from '@/hooks/connectionData'
import { formatWithThousandSep } from '@/utils/utils'
import CardDto from '@/interfaces/CardDto'
import { useAuth } from '@/hooks/useAuth'
import { api } from '@/utils/api'

export const MarketScreen = () => {
  const { userData } = useAuth()
  const { data, isLoading } = useSWR(`/vehicles/pub/${userData?.organization?._id}`, (url) => api.get<CardDto[]>(url))
  const [selected, setSelected] = useState<string | null>(null)

  return (
    <>
      <ScreenWrapper>
        <Heading>Market</Heading>
        {isLoading && <Spinner />}
        <Grid columns={{ md: '2' }} width="100%" gap="2">
          {data?.data.map(({ id, vehicle }) => (
            <Card key={id} onClick={() => setSelected(id)}>
              <Flex direction="row" gap="2">
                <Inset side="left" style={{ minWidth: '12rem' }}>
                  <Box
                    minHeight="10rem"
                    style={{
                      backgroundImage: `url(${vehicle?.firstImageUrl && makeUrlImage(vehicle?.firstImageUrl)})`,
                      backgroundColor: 'var(--gray-5)',
                      backgroundPosition: 'center',
                      backgroundSize: 'cover',
                    }}
                  ></Box>
                </Inset>
                <Flex direction="column" flexGrow="1" gap="2">
                  <Flex direction="row" wrap="wrap" gap="1" justify="between">
                    <Flex direction="column">
                      <Text>
                        {vehicle.brand} {vehicle.model}
                      </Text>
                      <Text size="1" color="gray">
                        {vehicle.version}
                      </Text>
                    </Flex>
                    <Badge size="2">${formatWithThousandSep(vehicle.price)}</Badge>
                  </Flex>
                  <Flex direction="row" wrap="wrap" gap="1">
                    <Badge color="gray">{vehicle.year}</Badge>
                    <Badge color="gray">{formatWithThousandSep(vehicle.odometer)}km</Badge>
                    <Badge color="gray" variant="outline">
                      {vehicle.plate}
                    </Badge>
                  </Flex>
                </Flex>
              </Flex>
            </Card>
          ))}
        </Grid>
      </ScreenWrapper>

      {selected && <VehicleDialog id={selected} onClose={() => setSelected(null)} />}
    </>
  )
}
